import { AnimationClasses, TransitionStates } from './types';

export function animationClassesGenerator(classes: AnimationClasses) {
  const { from: enterFrom, to: enterTo, transition: enterTrans } = classes.enter;
  const { from: exitFrom, to: exitTo, transition: exitTrans } = classes.exit;

  const enterFromClasses = enterFrom.split(' ');
  const exitFromClasses = exitFrom.split(' ');
  const enterTransitionAndToClasses = enterTrans.split(' ').concat(enterTo.split(' '));
  const exitTransitionAndToClasses = exitTrans.split(' ').concat(exitTo.split(' '));

  return function getNodeAnimationClasses(state: TransitionStates) {
    let classesToAdd: string[] = [];
    let classesToRemove: string[] = [];

    if (state === 'enter') {
      classesToAdd = enterFromClasses;
    } else if (state === 'entering') {
      classesToRemove = enterFromClasses;
      classesToAdd = enterTransitionAndToClasses;
    } else if (state === 'entered') {
      classesToRemove = enterTransitionAndToClasses;
    } else if (state === 'exit') {
      classesToAdd = exitFromClasses;
    } else if (state === 'exiting') {
      classesToRemove = exitFromClasses;
      classesToAdd = exitTransitionAndToClasses;
    } else if (state === 'exited') {
      classesToRemove = exitTransitionAndToClasses;
    }

    return { classesToAdd, classesToRemove };
  };
}
